"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMathJax = void 0;

var _react = require("react");

var _Provider = require("../providers/Provider");

const useMathJax = () => {
  const MathJax = (0, _Provider.useMathJaxContext)();
  (0, _react.useEffect)(() => {
    updateMathContent();
  });

  function updateMathContent() {
    if (!MathJax || typeof MathJax.typesetPromise !== 'function') return;
    MathJax && MathJax.typesetPromise().catch(e => {
      if (!isTypeError(e)) console.log(e);
    });
  }

  function isTypeError(e) {
    return e instanceof TypeError; // MathJax unhandled type error bug
  }

  return [MathJax, updateMathContent];
};

exports.useMathJax = useMathJax;